import View from 'mixins/view';

const elements = {
  container: '.c-calendar-main-banner',
};

export default class extends View {
  constructor(model) {
    super(model);
    this.setRootEl($(elements.container));
  }
  createOtherBanner() {
    this.rootEl = $(`<div class='c-calendar-main-banner match-padding'></div>`);
  }
  hide() {
    this.rootEl.addClass('fn-hidden');
  }
  render() {
    const sponsors = this.model.get('sponsors');
    if (!sponsors.showPlayerAd && !sponsors.showIplaAd) {
      this.rootEl.addClass('fn-hidden');
      this.rootEl.html('');
      return false;
    }

    // fixme move the link to backend
    let html = '';
    if (sponsors.showPlayerAd) {
      html += `
          <a class="cmb-sponsor-container" href="http://pubads.g.doubleclick.net/gampad/clk?id=5761150483&iu=/21308365" target="_blank">
            <img class="cmb-sc-desktop" src="/img/banners/view-in-player-2022.jpg" />
            <img class="cmb-sc-mobile" src="/img/banners/view-in-player-mobile-2022.jpg" />
          </a>
          <img src="https://ad.doubleclick.net/ddm/trackimp/N8765.2186708REALMADRYT.PL/B20522346.311010170;dc_trk_aid=449396417;dc_trk_cid=104879589;ord=[timestamp];dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;gdpr=\${GDPR};gdpr_consent=\${GDPR_CONSENT_755};ltd=?" border="0" height="1" width="1" alt="Advertisement">
      `;
    }
    if (sponsors.showIplaAd) {
      html += `
          <a class="cmb-sponsor-container" href="https://bit.ly/RealMecze" target='_blank'>
            <img class="cmb-sc-desktop" src="/img/banners/view-in-canal-plus.jpg" alt='canal plus banner' />
            <img class="cmb-sc-mobile" src="/img/banners/view-in-canal-plus-mobile.jpg" alt='canal plus banner' />
          </a>
      `;
    }
    this.rootEl
    .removeClass('fn-hidden')
    .html(html);
  }
};



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/matchCalendar/event/main-day-banner-view.js